import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { SociedadesAdapter, SociedadUser } from '../../../../../infraestructure/persistence/rest/SociedadesAdapter';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { useUserSettings } from '../../../context/CurrentUserContext';
import { Screen } from './screen';

export const ListaSociedadesContainer = forwardRef((props:any, ref:any) => {
	
	const {user,actions, handleOnSave, sociedadesUsuario} = props
	const api = new SociedadesAdapter();
	const { exceptionError, resultError, launchNotification } = useNotifications();
	//const {setCurrentUser} = useUserSettings();
	let [Sociedades, setSociedades] = useState<any>([]);
	let [SociedadesUser, setSociedadesUser] = useState<any>([]);
	let result: any;

	useEffect(()=>{
		getSociedades();
	},[])
  
	useEffect(()=>{
		if(user!==undefined && sociedadesUsuario!==undefined){
			setSociedadesUser(sociedadesUsuario);
		}else{
			if(user && user.tieneSociedades){getSociedadesUser(user)}
		}
	},[user,sociedadesUsuario])

	const getSociedades = async () => {
		try {
			result = await api.ListarSociedades();
			if(result.data && result.data!=="")
			{
				setSociedades([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  	};

	const getSociedadesUser = async (user:any) => {
		try {
			result = await api.ListarSociedades(user.dni);
			if(result.data && result.data!=="")
			{
				setSociedadesUser([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  	};

	  const addSociedadesUsuario = async (sociedades: string) => {
		try {
			const apiUser = new UsuariosAdapter();
			const result:any = await apiUser.AgregarSociedadesUsuario(user.dni,sociedades);
			if(result.data && result.data!=="")
			{
				//setCurrentUser(sociedades.length>0 ? {'tieneSociedades':true} : {'tieneSociedades':false})
				launchNotification({type:"success",title:"Creación",message:"Se han cambiado las sociedades a un usuario."})
			}else{
				resultError()
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};

	const toAddSociedades = handleOnSave!==undefined ? handleOnSave : addSociedadesUsuario;

	const getDataUser = useMemo(()=> SociedadesUser.map((su:SociedadUser)=> su),[SociedadesUser])

  return <Screen data={Sociedades} dataUser={getDataUser} ref={ref} menu actions={actions} onSave={toAddSociedades} nombre={user?user.nombre:undefined}/>;
});

export default ListaSociedadesContainer;